import { coreComponentsTranslationRef } from '@backstage/core-components';
import { createTranslationMessages } from '@backstage/frontend-plugin-api';
import { TranslationBlueprint } from '@backstage/plugin-app-react';
import { catalogTranslationRef } from '@backstage/plugin-catalog';
import { catalogReactTranslationRef } from '@backstage/plugin-catalog-react';

/**
 * Catalog filter labels in the design's words (pt-BR). They replace the
 * default English messages, so every page that reuses these pickers
 * (catalog, API explorer…) reads the same.
 */
export const catalogReactMessages = TranslationBlueprint.make({
  name: 'byx-catalog-react',
  params: {
    resource: createTranslationMessages({
      ref: catalogReactTranslationRef,
      messages: {
        'catalogFilter.title': 'Filtros',
        'catalogFilter.buttonTitle': 'Filtros',
        'userListPicker.personalFilter.title': 'Pessoal',
        'userListPicker.personalFilter.ownedLabel': 'Meus',
        'userListPicker.personalFilter.starredLabel': 'Favoritos',
        'userListPicker.orgFilterAllLabel': 'Todos',
        'entityOwnerPicker.title': 'Dono',
        'entityTypePicker.title': 'Tipo',
        // The "all" option of the Tipo select doubles as its placeholder. The
        // Dono and Ciclo de vida pickers have no placeholder message.
        'entityTypePicker.optionAllTitle': 'Qualquer tipo',
        'entityLifecyclePicker.title': 'Ciclo de vida',
        'entitySearchBar.placeholder': 'Buscar',
        'favoriteEntity.addToFavorites': 'Adicionar aos favoritos',
        'favoriteEntity.removeFromFavorites': 'Remover dos favoritos',
        // Column titles of the stock catalog tables (Templates tab, entity
        // pages).
        'entityTableColumnTitle.name': 'Nome',
        'entityTableColumnTitle.owner': 'Dono',
        'entityTableColumnTitle.description': 'Descrição',
        'entityTableColumnTitle.tags': 'Tags',
        'entityTableColumnTitle.type': 'Tipo',
        'entityTableColumnTitle.lifecycle': 'Ciclo de vida',
        'entityTableColumnTitle.system': 'Sistema',
        'entityTableColumnTitle.title': 'Título',
      },
    }),
  },
});

/** Row actions of the catalog table (view, edit, star). */
export const catalogMessages = TranslationBlueprint.make({
  name: 'byx-catalog',
  params: {
    resource: createTranslationMessages({
      ref: catalogTranslationRef,
      messages: {
        'catalogTable.viewActionTitle': 'Abrir fonte',
        'catalogTable.editActionTitle': 'Editar',
        'catalogTable.starActionTitle': 'Adicionar aos favoritos',
        'catalogTable.unStarActionTitle': 'Remover dos favoritos',
        // Entries of the entity header's ⋯ menu (v2 entity page).
        'entityContextMenu.copyURLMenuTitle': 'Copiar URL',
        'entityContextMenu.copiedMessage': 'URL copiada.',
        'entityContextMenu.inspectMenuTitle': 'Inspecionar entidade',
        'entityContextMenu.unregisterMenuTitle': 'Remover',
        'entityContextMenu.moreButtonTitle': 'Mais ações',
        'entityContextMenu.moreButtonAriaLabel': 'Mais ações',
      },
    }),
  },
});

/**
 * Table chrome (search box, actions header, pagination). Shared by every
 * Backstage table, so they all switch to pt-BR together.
 */
export const tableMessages = TranslationBlueprint.make({
  name: 'byx-table',
  params: {
    resource: createTranslationMessages({
      ref: coreComponentsTranslationRef,
      messages: {
        'table.body.emptyDataSourceMessage': 'Nada para mostrar',
        'table.pagination.firstTooltip': 'Primeira página',
        'table.pagination.labelDisplayedRows': '{from}–{to} de {count}',
        'table.pagination.labelRowsSelect': 'linhas',
        'table.pagination.lastTooltip': 'Última página',
        'table.pagination.nextTooltip': 'Próxima página',
        'table.pagination.previousTooltip': 'Página anterior',
        'table.toolbar.search': 'Filtrar',
        'table.header.actions': 'Ações',
      },
    }),
  },
});
